'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.KeyboardSave', []).directive('rmKeyboardSave', require('./directives/KeyboardSaveDirective')).controller('KeyboardSaveController', require('./controllers/KeyboardSaveController'));